import { isEmpty, isString } from 'lodash';

export default function deselected(selected) {
  return isString(selected) && isEmpty(selected);
}
